module.exports = __webpack_public_path__ + "src/assets/img/mMeeting_small2.d9af0e3e.jpg";